<template>
<div>
  <b-card>
    <grid-filters grid-data="theGrid" :fields="gridFilters" ></grid-filters>
    <Grid ref="theGrid" name="independentScorecardResults" v-bind:url="url" v-bind:preload="preload" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'independentScorecardResults',
  components: {
    Grid
  },
  data() {
    return {
      gridFilters: [{
        field:'independent_operator_id',
        modal:'independent-operators-modal',
        foreign: 'id',
        placeholder: 'Operador'
      }],
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'independent_operator_id': {
          type: 'number'
        }
      },
      preload: [{
        api: 'scorecard-independents/operators/lst',
        field: 'independent_operator_id'
      }],
      url: 'scorecard-independents/results',
      columns: [{
        field: 'ym',
        title: 'Ano/Mês',
        width: '120px'
      },
      {
        field: 'spreads',
        title: 'Spreads',
        width: '120px',
        values: lists.yesNo
      },
      {
        field: 'independent_operator_id',
        title: 'Operador',
        width: '220px'
      },
      {
        field: 'sellin1',
        title: 'Sellin Top10',
        width: '160px'
      },
      {
        field: 'sellin1ok',
        title: 'Cumpre',
        width: '160px',
        values: lists.yesNo
      },
      {
        field: 'sellin2',
        title: 'Sellin Total',
        width: '160px'
      },
      {
        field: 'sellin2ok',
        title: 'Cumpre',
        width: '160px',
        values: lists.yesNo
      },
      {
        field: 'sellin3prize',
        title: 'Prémio Sellin',
        width: '160px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  }
}
</script>
